import {
  hasNativePage,
  nativeRedirect
} from '@/utils/native_interactions/native_redirect'
import { h5Redirect } from '@/utils/native_interactions/h5_wrap/redirect'

export const autoRedirect = url => {
  if (hasNativePage(url)) {
    nativeRedirect(url)
  } else {
    h5Redirect(url)
  }
}
